import styled from "@emotion/styled";

const MapWrapper = styled.div`
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  flex: 2;
  min-height: 500px;
`;

export default MapWrapper;
